/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DownloadInputs */

const en_download = /** @type {(inputs: DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

const fr_download = /** @type {(inputs: DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger`)
};

const de_download = /** @type {(inputs: DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herunterladen`)
};

const it_download = /** @type {(inputs: DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scaricamento`)
};

const ru_download = /** @type {(inputs: DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скачать`)
};

const es_download = /** @type {(inputs: DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar`)
};

const zh_cn2_download = /** @type {(inputs: DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载`)
};

const ja_download = /** @type {(inputs: DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダウンロード`)
};

const hi_download = /** @type {(inputs: DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डाउनलोड करना`)
};

const pt_pt2_download = /** @type {(inputs: DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

/**
* | output |
* | --- |
* | "Download" |
*
* @param {DownloadInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const download = /** @type {((inputs?: DownloadInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DownloadInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_download(inputs)
	if (locale === "de") return de_download(inputs)
	if (locale === "it") return it_download(inputs)
	if (locale === "ru") return ru_download(inputs)
	if (locale === "es") return es_download(inputs)
	if (locale === "zh-CN") return zh_cn2_download(inputs)
	if (locale === "ja") return ja_download(inputs)
	if (locale === "hi") return hi_download(inputs)
	if (locale === "pt-PT") return pt_pt2_download(inputs)
	return en_download(inputs)
});